import React, { useState, useEffect } from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const FirstModal = ({
  id,
  closeReviewPanel,
  isReviewPanelOpen,
  openIdentityPanel,
  firstName,
  lastName,
  gender,
  middleName,
  dob,
  username,
  setUsername,
  identification,
  openPhotoModal,
  setFirstName,
  setLastName,
  setMiddleName,
  setIdentification,
  setGender,
  setDob,
  handlePersonalInformation,
  loading,
}) => {
  const today = new Date()?.toISOString()?.split("T")[0];

  const [isInputsFilled, setIsInputsFilled] = useState(false);

  const handleBackButtonClick = () => {
    setFirstName("");
    setLastName("");
    setMiddleName("");
    setIdentification("");
    setGender("");
    setDob("");
    setUsername("");
    openIdentityPanel();

    closeReviewPanel();
  };

  useEffect(() => {
    const areInputsFilled = !!(
      firstName &&
      lastName &&
      middleName &&
      dob &&
      gender &&
      username
    );
    setIsInputsFilled(areInputsFilled);
  }, [firstName, lastName, middleName, gender, dob, username]);

  return (
    <SlidePanel isOpen={isReviewPanelOpen} onClose={closeReviewPanel}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        <div
          onClick={closeReviewPanel}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        <div className="flex h-full w-full">
          <div className="w-full flex flex-col">
            <div className="mt-4 px-5">
              <p className="text-[#000] text-xl font-bold">
                New Member - Personal Details
              </p>
              <div className="text-[#000] font-[300] text-[15px]">
                <p>
                  Check if personal details match with the National ID uploaded
                </p>
              </div>
            </div>
            <div className="flex-1 overflow-y-auto px-5 pb-6">
              <div className="w-full mt-5 space-y-5">
                <div className="w-full flex flex-col">
                  <label className="mb-1 text-md font-medium">
                    Identity Document Number
                  </label>
                  <input
                    type="text"
                    value={identification}
                    onChange={(e) => setIdentification(e.target.value)}
                    className="px-3 h-10 bg-[#EAEAEA] rounded"
                  />
                </div>

                <div className="w-full flex flex-col">
                  <label className="mb-1 text-md font-medium">First name</label>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="px-3 h-10 bg-[#EAEAEA] rounded"
                  />
                </div>

                <div className="w-full flex flex-col">
                  <label className="mb-1 text-md font-medium">
                    Middle name
                  </label>
                  <input
                    type="text"
                    value={middleName}
                    onChange={(e) => setMiddleName(e.target.value)}
                    className="px-3 h-10 bg-[#EAEAEA] rounded"
                  />
                </div>

                <div className="w-full flex flex-col">
                  <label className="mb-1 text-md font-medium">Last name</label>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="px-3 h-10 bg-[#EAEAEA] rounded"
                  />
                </div>

                <div className="w-full flex flex-col">
                  <label className="mb-1 text-md">Date of Birth</label>
                  <input
                    type="date"
                    value={dob}
                    max={today}
                    onChange={(e) => setDob(e.target.value)}
                    className="h-10 px-4 bg-[#EAEAEA] border rounded"
                  />
                </div>

                <div className="w-full flex flex-col">
                  <label className="mb-1 text-md font-medium">Gender</label>
                  <select
                    value={gender || ""}
                    onChange={(e) => setGender(e.target.value)}
                    className="h-10 px-3 bg-[#EAEAEA] rounded"
                  >
                    <option value="" disabled>
                      Choose gender
                    </option>
                    <option value={gender}>{gender}</option>
                    {["MALE", "FEMALE"]
                      .filter((g) => g !== gender)
                      .map((g) => (
                        <option key={g} value={g}>
                          {g.charAt(0).toUpperCase() + g.slice(1)}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="flex w-full flex-col">
                  <label className="mb-1 text-md font-medium">Username</label>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="px-3 h-10 bg-[#EAEAEA] rounded"
                  />
                </div>
              </div>
            </div>
            <div className="px-5 flex flex-col ">
              <button
                disabled={!isInputsFilled || loading}
                onClick={handlePersonalInformation}
                className={`px-8 py-2.5 rounded text-white ${
                  isInputsFilled
                    ? "bg-[#005C53]"
                    : "bg-[#D9D9D9] pointer-events-none"
                } ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                {loading ? (
                  <div className="flex items-center justify-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    Completing ...
                  </div>
                ) : (
                  "Yes Complete, Details Are Correct"
                )}
              </button>
              <button
                onClick={handleBackButtonClick}
                className="flex items-center justify-center mt-2 mb-2 border border-[#FF5757] text-[#FF5757] px-7 py-2 rounded"
              >
                No, this doesn’t look right. Scan again
              </button>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default FirstModal;
